import { ImageInfo } from './common';

export class PaymentTransaction { //common for payment request and credit or debit
    constructor() {
        this.serviceType = null;
        this.marginType = null;
        this.bankId = null;
        this.bankReferenceId = null;
        this.bankReceipt = new ImageInfo();
        this.subdomain = null
    }
    public subdomain: string;
    public amount: string;
    public userId: string;
    public transferType: string;
    public depositedDate: Date;
    public bankReferenceId: string;
    public bankId: string;
    public walletType: string;
    public transactionType: string; //['Credit, Debit']
    public serviceType: string; //[,'Recharge' ,'Money Transfer', 'Bill Payment', 'AEPS' 'Micro ATM' ] respectively [1,2,3,4,5]
    public remarks: string;
    public marginType: string;//  ['Commission', 'Charge']
    public flat: boolean;
    public performedBy: string;
    public transactionDate: Date;
    public bankReceipt: ImageInfo;
    public requestedBy: string;
    public requestedTo: string;
    public requestedReason: string;
    public requestedOn: Date;
    public status: string;
    public updatedOn: Date;
    public declinedReason: string;
}
